export default function PHP_yield_from() {
  return (
    <div>
      <h1>PHP_yield_from</h1>
    </div>
  );
}
